import { Dispatch } from 'redux';
import { IApiReturnObject, preProcessOrder as preProcessOrderLib } from '@bold-commerce/checkout-frontend-library';
import { checkErrorAndProceedToNextPage, getApplicationStateFromLib } from 'src/library';
import { HistoryLocationState } from 'react-router';
import { actionSetAppStateValid, actionShowHideOverlayContent } from 'src/action';
import { getCheckoutUrl, handleErrorIfNeeded } from 'src/utils';
import { API_RETRY, Constants, errorFields, errorSubTypes } from 'src/constants';
import { IOrderInitialization } from 'src/types';
import { useRemoveAllFlashErrors } from 'src/hooks';
export function preProcessOrder(history: HistoryLocationState) {
    return async function preProcessOrderThunk(dispatch: Dispatch, getState: () => IOrderInitialization): Promise<void> {
        useRemoveAllFlashErrors(dispatch, getState().errors);
        const { errors } = getState();

        if (errors.length === 0) {
            try {
                const response: IApiReturnObject = await preProcessOrderLib(API_RETRY);
                handleErrorIfNeeded(response, dispatch, getState);

                if (response.success) {
                    await dispatch(actionSetAppStateValid('preOrderProcessed', true));
                    await dispatch(getApplicationStateFromLib);
                    await dispatch(checkErrorAndProceedToNextPage(Constants.THANK_YOU_ROUTE, 'paymentPageButton', history, true));
                    dispatch(actionShowHideOverlayContent(false));
                } else {
                    const error = errors.find((error) => error.field === errorFields.inventory && error.sub_type === errorSubTypes.insufficient_stock);

                    if (error) {
                        history.replace(getCheckoutUrl(Constants.OUT_OF_STOCK_ROUTE));
                    }

                    dispatch(actionShowHideOverlayContent(false));
                }
            } catch (error) {
                handleErrorIfNeeded({ error } as IApiReturnObject, dispatch, getState);
            }
        } else {
            dispatch(actionShowHideOverlayContent(false));
        }
    };
}
